import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { HomePage } from './pages/HomePage';
import { SearchPage } from './pages/SearchPage';
import { CartPage } from './pages/CartPage';
import { WICEBTGuidePage } from './pages/WICEBTGuidePage';
function AnimatedRoutes() {
  const location = useLocation();
  return <AnimatePresence mode="wait" data-id="element-0">
      <motion.div key={location.pathname} initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: 'easeInOut'
    }} data-id="element-1">
        <Routes location={location} data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/search" element={<SearchPage data-id="element-6" />} data-id="element-5" />
          <Route path="/cart" element={<CartPage data-id="element-8" />} data-id="element-7" />
          <Route path="/wic-ebt-guide" element={<WICEBTGuidePage data-id="element-10" />} data-id="element-9" />
        </Routes>
      </motion.div>
    </AnimatePresence>;
}
export function App() {
  return <Router data-id="element-11">
      <div className="min-h-screen bg-[#FAF8F5]" data-id="element-12">
        <AnimatedRoutes data-id="element-13" />
      </div>
    </Router>;
}